import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { GlobalService } from 'src/app/services/global.service';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { HttpService } from 'src/app/services/http.service';
import { DatepickerOptions } from 'ng2-datepicker';
import * as enLocale from 'date-fns/locale/en';
import { configs } from 'src/app/configs/app.config';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { IDropdownSettings } from 'ng-multiselect-dropdown';


@Component({
  selector: 'app-add-new-alert',
  templateUrl: './add-new-alert.component.html',
  styleUrls: ['./add-new-alert.component.scss']
})
export class AddNewAlertComponent {
  public stream: boolean;
  public selectedLocations: string = "";
  public startDate: Date;
  public endDate: any;
  public successMessage: string = '';
  public errorMessage: string = "";
  public warningMessage = '';
  public selecteddownloadSpeed: string = "";
  public selectedNetwork: string = "";
  public selectedKpi: string = "";
  public selectedAppVersion: string = "";
  public selectedDeviceCategory: string = "";
  public selectedTimeWindow: string = "";
  public selectedItems = [];
  public dropdownSettings: IDropdownSettings = {};
  public alertName: any;
  public appName: Array<any> = [];
  public kpiList: Array<any> = [];
  
  public optionsStartDate: DatepickerOptions = {
    locale: enLocale,
    placeholder: 'Select Date',
    displayFormat: 'DD/MM/YY'
  };
  public optionsEndDate: DatepickerOptions = {
    locale: enLocale,
    placeholder: 'Select Date',
    displayFormat: 'DD/MM/YY',
  };
  addAlert: FormGroup;
  constructor(private ngxService: NgxUiLoaderService, public globalService: GlobalService, public cd: ChangeDetectorRef, private formBuilder: FormBuilder, public httpService: HttpService) {
    this.addAlert = this.formBuilder.group({
      group_fk_select_name: ['', Validators.required],
      group_fk: [''],
      alertName: [''],
      value: [],
      location_select_name: [''],
      startDate: [''],
      endDate: [''],
      // stream: [''],
      location: [''],
      operator_select_name: [''],
      operator: [''],
      downloadSpeed_select_name: [''],
      downloadSpeed: [''],
      kpi_select_name: [''],
      kpi: [''],
      timeWindow: [''],
      timeWindow_select_name: [''],
      appVersion: [''],
      appVersion_select_name: [''],
      appName: [''],
      appName_select_name: [''],
      condition: [''],
      condition_select_name: [''],
      deviceCategory: [''],
      deviceCategory_select_name: [''],
      locationArray:[],
      timeWindowArray:[],
      deviceCategoryArray:[],
      appVersionArray:[],
      operatorArray:[],
      downloadSpeedArray:[],
      kpiType :[''],
      kpiType_select_name:[''],
    });

  }
  ngOnInit() {

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: false
    };

    if (this.globalService && this.globalService.order_id)
      this.fetchConditionList();
    else {
      let inter = setInterval(() => {
        if (this.globalService && this.globalService.order_id) {
          clearInterval(inter);
          this.fetchConditionList();
        }
      }, 100);
    }
    this.addAlert.get('kpiType').setValue('Index');
  }


  public changeSelection(selectedValue): void {
    setTimeout(() => {
      let option = selectedValue['fieldName'];
      this.addAlert.controls[option].setValue(selectedValue['id']);
      if(selectedValue['fieldName']=='kpiType'){
        this.addAlert.patchValue({
           'kpi_select_name':'',
            'kpi':''
        });
        this.fetchKpiList(this.addAlert['controls']['kpiType']['value']);
      }
    }, 0);
  }
  public fetchKpiList(val): void {
    this.kpiList = [];
    this.httpService.createGetRequest(configs['api']['fetchKpiList'] + this.globalService.order_id+'?raw='+val).subscribe((response: any) => {
      if (response) 
        this.kpiList = this.globalService.toObject('', response);
        // this.kpiList = this.kpiList.slice();
    });
  }
  fromdateSelected: boolean = false;

  dateSelect(event) {
    this.endDate = null;
    this.optionsEndDate.minDate = event;
    this.cd.detectChanges();
    setTimeout(() => {
      this.fromdateSelected = true;
    }, 0);
  }
  clean(obj) {
    var arr = [];
    for (var propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined || obj[propName] === "--" || obj[propName] === "aN--NaN" || obj[propName] === "NaN--NaN" || obj[propName].length === 0 || obj[propName] === " " || obj[propName] === "select" || obj[propName] === "Select" || (obj[propName] && obj[propName][0] === "select")) {
        delete obj[propName];
      }
    }
    return obj;
  }
  public addNewAlert(): void {
    // this.ngxService.start();
    let url = configs['api']['addNewAlertApi'];

    if (this.addAlert['controls']['value']['value']!=null && this.addAlert['controls']['value']['value']!=undefined)   {
       if (isNaN(this.addAlert['controls']['value']['value'])) {
        this.warningMessage='Value should be a number';
        return;
      }
      if ((+ this.addAlert['controls']['value']['value'] < 1) || (+ this.addAlert['controls']['value']['value'] > 4)) {
        this.warningMessage='Value should in between 1 and 4';
        return;
      }
    }
    this.ngxService.start();
    this.httpService.createPostRequest(url, this.clean({
      // alertName: this.addAlert['controls']['alertName']['value'] ? this.addAlert['controls']['alertName']['value'] : undefined,
      // condition: this.addAlert['controls']['condition']['value'] ? this.addAlert['controls']['condition']['value'] : undefined,
      // value: this.addAlert['controls']['value']['value'],
      // location: this.addAlert['controls']['location']['value'] ? [this.addAlert['controls']['location']['value']] : undefined,
      // startDate: this.globalService.convertDate(this.addAlert['controls']['startDate']['value']) ? this.globalService.convertDate(this.addAlert['controls']['startDate']['value']) : "",
      // endDate: this.globalService.convertDate(this.addAlert['controls']['endDate']['value']) ? this.globalService.convertDate(this.addAlert['controls']['endDate']['value']) : "",
      // operator: this.addAlert['controls']['operator']['value'] ? [this.addAlert['controls']['operator']['value']] : undefined,
      // scoreName: this.addAlert['controls']['kpi']['value'] ? this.addAlert['controls']['kpi']['value'] : undefined,
      // downloadSpeed: this.addAlert['controls']['downloadSpeed']['value'] ?[ this.addAlert['controls']['downloadSpeed']['value']] : undefined,
      // appVersion: this.addAlert['controls']['appVersion']['value'] ? this.addAlert['controls']['appVersion']['value'] : undefined,
      // deviceCategory: this.addAlert['controls']['deviceCategory']['value'] ? this.addAlert['controls']['deviceCategory']['value'] : undefined,
      // timeWindow: this.addAlert['controls']['timeWindow']['value'] ? this.addAlert['controls']['timeWindow']['value'] : undefined,
      // appName: this.addAlert['controls']['appName']['value'] ? this.addAlert['controls']['appName']['value'] : undefined,
      // liveStreaming: this.addAlert['controls']['stream']['value'] ? this.addAlert['controls']['stream']['value'] : undefined,

       
      alertName: this.addAlert['controls']['alertName']['value'] ? this.addAlert['controls']['alertName']['value'] : undefined,
      condition: this.addAlert['controls']['condition']['value'] ? this.addAlert['controls']['condition']['value'] : undefined,
      value: this.addAlert['controls']['value']['value'],
      location: this.addAlert['controls']['locationArray']['value'] ? this.globalService.getDataAsString(this.addAlert['controls']['locationArray']['value']) : undefined,
      startDate: this.globalService.convertDate(this.addAlert['controls']['startDate']['value']) ? this.globalService.convertDate(this.addAlert['controls']['startDate']['value']) : "",
      endDate: this.globalService.convertDate(this.addAlert['controls']['endDate']['value']) ? this.globalService.convertDate(this.addAlert['controls']['endDate']['value']) : "",
      operator: this.addAlert['controls']['operatorArray']['value'] ? this.globalService.getDataAsString(this.addAlert['controls']['operatorArray']['value']): undefined,
      scoreName: this.addAlert['controls']['kpi']['value'] ? this.addAlert['controls']['kpi']['value'] : undefined,
      downloadSpeed: this.addAlert['controls']['downloadSpeedArray']['value'] ? this.globalService.getDataAsString(this.addAlert['controls']['downloadSpeedArray']['value']): undefined,
      appVersion: this.addAlert['controls']['appVersionArray']['value'] ? this.globalService.getDataAsString(this.addAlert['controls']['appVersionArray']['value']): undefined,
      deviceCategory: this.addAlert['controls']['deviceCategoryArray']['value'] ? this.globalService.getDataAsString(this.addAlert['controls']['deviceCategoryArray']['value']): undefined,
      timeWindow: this.addAlert['controls']['timeWindowArray']['value'] ? this.globalService.getDataAsString(this.addAlert['controls']['timeWindowArray']['value']) : undefined,
      appName: this.addAlert['controls']['appName']['value'] ? this.addAlert['controls']['appName']['value'] : undefined,
      // liveStreaming: this.addAlert['controls']['stream']['value'] ? this.addAlert['controls']['stream']['value'] : undefined,
      raw:this.addAlert['controls']['kpiType']?((this.addAlert['controls']['kpiType']['value']=='Index'|| this.addAlert['controls']['kpiType']['value']==false)?false:true):false,
    }), this.globalService.order_id
    ).subscribe((res) => {
      this.ngxService.stop();
      this.successMessage = "Alert Added Successfully";
      this.globalService.scrollToTop();

      setTimeout(() => {
        this.forPopupOpen('viewAlert');
      }, 3000);
    },
      (error) => {
        this.ngxService.stop();
        this.errorMessage =    error && error['error'] && error.error['statusMessage'] &&
        (error.error['statusCode'] && error.error['statusCode'] !== 406)  ? error.error['statusMessage'] : '';
        this.warningMessage = (error.error['statusCode'] && error.error['statusCode'] === 406) ? error.error['statusMessage'] : '';
        setTimeout(() => {
          this.errorMessage = "";
          this.warningMessage = "";
        }, 5000);
      });
  }

 

  forPopupOpen(key) {
    if(key)
    this.globalService.showPopUp = key;
    document.body ? document.body.classList.add('no-scroll') : '';
  }

  forPopupClose() {
    this.globalService.showPopUp = "";
    document.body ? document.body.classList.remove('no-scroll') : '';
  }
  
  public conditionList: Array<any> = [];
  public fetchConditionList(): void {
    this.conditionList = [];
    this.httpService.createGetRequest(configs['api']['fetchConditionList'] + this.globalService.order_id)
      .subscribe((res) => {
        this.conditionList = this.globalService.toObject('', res);
      });
  }
}
